import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { IButton, TranslateService } from '@devinforius/i-essentials';
import { ToastrService } from 'ngx-toastr';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-choose-source-type-modal',
  templateUrl: './choose-source-type-modal.component.html',
  styleUrls: ['./choose-source-type-modal.component.scss'],
})
export class ChooseSourceTypeModalComponent implements OnInit {
  public form = new UntypedFormGroup({
    editeurSourceType: new UntypedFormControl(null, Validators.required),
  });
  public sources = [
    { label: 'Externe', value: 'Externe' },
    { label: 'Web', value: 'Web' },
  ];

  public titleButtons: IButton[] = [
    {
      text: 'homeCourrier.buttons.back',
      styleClass: 'blue',
      click: () => {
        this.ref.close();
      },
    },
    {
      text: 'validate',
      styleClass: 'green',
      click: () => {
        this.submit();
      },
    },
  ];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public toastr: ToastrService,
    private translater: TranslateService
  ) {}

  ngOnInit(): void {
    this.titleButtons = this.titleButtons.map((button) => ({ ...button, text: this.translater.translate(button.text) }));
  }

  submit(): void {
    if (this.form.valid) {
      this.ref.close(this.form.value);
    } else {
      this.toastr.error('Veuillez choisir une source!');
    }
  }
}
